import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const customerService = {
  get_all: async (page = 1, limit = 10, token) => {
    const response = await https.get(
      `${API_ROUTES.CUSTOMER.GET_ALL}?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_admin_customers_short: (token, params) => {
    const uri = API_ROUTES.CUSTOMER.GET_ADMIN_CUSTOMERS_SHORT;
    return https.get(uri, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_by_id: async (id, token) => {
    const response = await https.get(`${API_ROUTES.CUSTOMER.GET_BY_ID}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  create: async (data, token) => {
    const response = await https.post(`${API_ROUTES.CUSTOMER.CREATE}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  update: async (id, data, token) => {
    const response = await https.put(
      `${API_ROUTES.CUSTOMER.UPDATE}/${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  delete: async (id, token) => {
    const response = await https.delete(`${API_ROUTES.CUSTOMER.DELETE}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  search_list: async (page, limit, search, from_date, to_date, token) => {
    const response = await https.get(
      `${API_ROUTES.CUSTOMER.SEARCH_LIST}?page=${page}&limit=${limit}&search_value=${search}&from_date=${from_date}&to_date=${to_date}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
